export default __webpack_public_path__ + "media/images/preview-eb6f7e884a299ed96869213389041c67.png";